"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _AaPassengerRoomSelectionRoom = _interopRequireDefault(require("./AaPassengerRoomSelection-Room.component"));

var _AaPassengerRoomSelectionPopup = _interopRequireDefault(require("./AaPassengerRoomSelection-Popup.container"));

var _AaPassengerRoomSelection = _interopRequireDefault(require("./AaPassengerRoomSelection.styles"));

var _AaPassengerRoomSelection2 = require("./AaPassengerRoomSelection.model");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var RoomSelectionLabel = function RoomSelectionLabel(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: _AaPassengerRoomSelection["default"].selectRoomMessage
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaIconComponent, {
    controls: {
      iconName: _crossPlatformComponents.AaIconTypes.WARNING_ICON,
      iconStyle: {
        height: 16,
        width: 16,
        color: "#C94318",
        marginLeft: 0,
        marginRight: 6
      }
    }
  })), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: _AaPassengerRoomSelection["default"].selectRoomMessageInner
  }, props.translation.moreRoomsWarningLabel)));
};

var RoomAddLink = function RoomAddLink(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      flex: 1,
      flexDirection: "row"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
    accessibilityRole: "button",
    style: {
      flex: 1
    },
    onPress: props.callback
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: [_AaPassengerRoomSelection["default"].stepperButtonText, {
      color: '#4b4fa6',
      top: -2,
      marginRight: 4
    }]
  }, "+")), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: _AaPassengerRoomSelection["default"].link
  }, props.translation.addMoreRoomsLabel)))));
};

var AaPassengerSelectionPopup = function AaPassengerSelectionPopup(props) {
  var _useState = (0, _react.useState)(props.data),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      roomOccupancy = _useState2[0],
      setRoomOccupancy = _useState2[1];

  var passengerSelectionID = 'aa-passenger-selection';
  (0, _react.useEffect)(function () {
    setRoomOccupancy(props.data);
  });

  var onDonePress = function onDonePress() {
    props.controls.onBackdropClose(false);
  };

  var changePaxCount = function changePaxCount(index) {
    return function (key, type) {
      var _objectSpread2;

      var roomCount = roomOccupancy[index];
      var count = roomCount[key];
      var childAges = roomCount.childAges || [];

      if (type === _AaPassengerRoomSelection2.STEPPER_EVENTS.INCREMENT) {
        count++;

        if (key === _AaPassengerRoomSelection2.PASSENGER_TYPE.CHILD) {
          childAges.push({
            value: 1
          });
        }
      } else {
        count--;
        if (childAges.length > 0 && key === _AaPassengerRoomSelection2.PASSENGER_TYPE.CHILD) childAges.pop();
      }

      var updatedRoomOccupancy = [].concat((0, _toConsumableArray2["default"])(roomOccupancy.slice(0, index)), [_objectSpread(_objectSpread({}, roomCount), {}, (_objectSpread2 = {}, (0, _defineProperty2["default"])(_objectSpread2, key, count), (0, _defineProperty2["default"])(_objectSpread2, "childAges", childAges), _objectSpread2))], (0, _toConsumableArray2["default"])(roomOccupancy.slice(index + 1)));
      setRoomOccupancy(updatedRoomOccupancy);
      props.controls.onChangeData(updatedRoomOccupancy);
    };
  };

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      showAddRoomLabel = _useState4[0],
      setShowAddRoomLabel = _useState4[1];

  var addRoom = function addRoom() {
    if (roomOccupancy.length === _AaPassengerRoomSelection2.MAX_ROOM_COUNT) {
      return;
    }

    var enableMultipleRooms = props.controls.enableMultipleRooms;

    if (!enableMultipleRooms) {
      setShowAddRoomLabel(true);
      return;
    }

    var newRoom = (0, _AaPassengerRoomSelection2.buildRoomModel)();
    setRoomOccupancy([].concat((0, _toConsumableArray2["default"])(roomOccupancy), [newRoom]));
    props.controls.onChangeData([].concat((0, _toConsumableArray2["default"])(roomOccupancy), [newRoom]));
  };

  var removeRoom = function removeRoom(index) {
    return function () {
      var updatedOccupancy = [].concat((0, _toConsumableArray2["default"])(roomOccupancy.slice(0, index)), (0, _toConsumableArray2["default"])(roomOccupancy.slice(index + 1)));
      setRoomOccupancy(updatedOccupancy);
      props.controls.onChangeData(updatedOccupancy);
    };
  };

  var selectionStepperConfig = {
    controls: {
      description: {
        adult: {
          label: props.translation.adultLabel,
          sublabel: props.translation.adultDescLabel
        },
        child: {
          label: props.translation.childLabel,
          sublabel: props.translation.childDescLabel
        },
        infant: {
          label: props.translation.infantLabel,
          sublabel: props.translation.infantDescLabel
        }
      }
    }
  };
  /**
   * Configuration Object for `Done` button
   */

  var aaButtonConfig = {
    controls: {
      onButtonPress: onDonePress,
      customStyle: {
        container: {
          paddingVertical: 10
        }
      }
    },
    data: {
      text: props.translation.paxDoneLabel
    }
  };
  /**
   * EventListeners that only be triggered when Platform is web and not mobile
   *
   * This is used for accessibility
   */

  if (!props.controls.isMobilePlatform && _reactNativeWeb.Platform.OS === 'web') {
    var onFocusListener = function onFocusListener() {
      document.addEventListener('keyup', keyUpHandler, false);
    };

    var keyUpHandler = function keyUpHandler() {
      var element = document.getElementById(passengerSelectionID);

      if (!element) {
        return;
      }

      var isChild = element.contains(document.activeElement);

      if (!isChild) {
        onDonePress();
      }
    };

    var handleClickOutside = function handleClickOutside(e) {
      var element = document.getElementById(passengerSelectionID);

      if (!element) {
        return;
      }

      if (e.target !== element && !element.contains(e.target)) {
        onDonePress();
        return;
      }
    };

    (0, _react.useEffect)(function () {
      onFocusListener(); // Bind the event listener

      document.addEventListener("mousedown", handleClickOutside, false);
      return function () {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside, false);
        document.removeEventListener("keyup", keyUpHandler, false);
      };
    }, []);
  }

  var isMobile = props.controls.isMobilePlatform || props.controls.isMobileLayout;
  var showAddRoom = roomOccupancy.length !== _AaPassengerRoomSelection2.MAX_ROOM_COUNT;
  var canRemove = roomOccupancy.length > 1;
  return /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelectionPopup["default"], {
    isMobile: isMobile,
    openModal: props.controls.openModal,
    onClose: onDonePress,
    passengerSelectionID: passengerSelectionID,
    leftAligned: props.controls.isLeftAligned
  }, roomOccupancy.map(function (roomCount, index) {
    return /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelectionRoom["default"], {
      key: index,
      roomCount: roomCount,
      roomNumber: index + 1,
      translation: props.translation,
      selectionStepperConfig: selectionStepperConfig,
      min: props.controls.min,
      max: props.controls.max,
      stepperClicked: changePaxCount(index),
      removeRoom: removeRoom(index),
      showRemove: canRemove && index === roomOccupancy.length - 1,
      ageList: props.ageList
    });
  }), showAddRoomLabel && /*#__PURE__*/_react["default"].createElement(RoomSelectionLabel, {
    translation: props.translation
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: [_AaPassengerRoomSelection["default"].buttonContainer, !showAddRoom && _AaPassengerRoomSelection["default"].reverseContainer]
  }, showAddRoom && /*#__PURE__*/_react["default"].createElement(RoomAddLink, {
    callback: addRoom,
    translation: props.translation
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: _AaPassengerRoomSelection["default"].button
  }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaButton, {
    controls: aaButtonConfig.controls,
    data: aaButtonConfig.data
  }))));
};

var _default = AaPassengerSelectionPopup;
exports["default"] = _default;